<ng-container *transloco="let t">
<ion-row class="d-flex align-items-center">
	@if (selectedProfile()) {
		<app-avatar
			class="mini-avatar"
			[src]="selectedProfile().imgUrl"
			[alt]="selectedProfile().username + ' user avatar'"
			[initials]="getInitials(selectedProfile().username)"
			[size]="40"
			[showStatus]="true"
			[status]="selected_status"
		></app-avatar>
	}
	@if (selectedProfile()) {
		<h5 class="mt-auto mb-auto">
		{{ selectedProfile().username.length > 16 ? ((selectedProfile().username | slice : 0 : 16) + '...') : selectedProfile().username }}
		@if (compatibilityScore() !== null && profileService.profile() && selectedProfile().uuid !== profileService.profile()!.uuid) {
			<span class="compat-score">
				{{ compatibilityScore() }}%
			</span>
		}
	</h5>
	}
</ion-row>

</ng-container>
